var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserTable',{attrs:{"extended-columns":true,"can-delete":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }